import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyNoAccessSeaweedEmptyState = lazy(() => import('./svg-components/no-access-seaweed-empty-state'));

const NoAccessSeaweedEmptyState = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyNoAccessSeaweedEmptyState {...rest} />
  </Suspense>
);

export default NoAccessSeaweedEmptyState;
